/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2021
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import './callout-with-media';
import './callout-with-media-copy';
import './callout-with-media-image';
import './callout-with-media-video';
import '../content-block/content-block-copy';
import '../content-block/content-block-heading';
